export default "/images/airplay.svg?904fa203d3b00466461eadbf9b38e9be";